<template>
  <CRow>
    <CCol col="12" lg="6">
      <CCard no-header>
        <CCardBody>
          <h3>
            {{$t("Batch.AddBatch")}}
          </h3>
          <CAlert
            :show.sync="dismissCountDown"
            color="primary"
            fade
          >
            ({{dismissCountDown}}) {{ message }}
          </CAlert>

            <CInput :label="$t('Batch.ReferenceLabel')" type="text" placeholder="Référence" v-model="batch.reference" disabled></CInput>

            <CSelect 
              :label="$t('Batch.TypeLabel')" 
              :value.sync="batch.product_type_id" 
              :plain="true" 
              :options="product_types"
              @change="setUpRef()"
            ></CSelect>


            <CSelect
                    :label="$t('Batch.SupplierLabel')"
                    :value.sync="batch.provider_id"
                    :plain="true"
                    :options="providers"
                    @change="setUpRef()"
            >
            </CSelect>

            <CInput :label="$t('Batch.PriceLabel')" type="number" v-model="batch.price"></CInput>

          <CButton color="success" @click="store()" class="w-100">{{$t('Button.Add')}}</CButton>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>

import {batchService, providerService, typeService} from "../../_services";
export default {
  name: 'EditUser',
  props: {
    caption: {
      type: String,
      default: 'User id'
    },
  },
  data: () => {
    return {
        batch: {
          reference: '',
          product_type_id: '',
          provider_id: '',
          price: '',
        },
        product_types: [],
        providers: [],
        message: '',
        dismissSecs: 7,
        dismissCountDown: 0,
        showDismissibleAlert: false,
        last_batch_id: ''
    }
  },
  methods: {
    setUpRef(){
      let type = this.product_types.find(x => x.value === this.batch.product_type_id).label;
      let type_chars = type.match(/\b(\w)/g); // ['J','S','O','N']
      type_chars = type_chars.join(''); // JSON

      let provider = this.providers.find(x => x.value === this.batch.provider_id).label;
      let provider_chars = provider.match(/\b(\w)/g); // ['J','S','O','N']
      provider_chars = provider_chars.join(''); // JSON

      this.batch.reference = type_chars+'-'+provider_chars+'-'+(this.last_batch_id+1)
    },
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/users'})
    },
    store() {
      batchService.create(this.batch).then(function (data) {
        console.log(data);
        this.message = "added successfully";
        this.showAlert();
        this.goBack();
      }.bind(this))
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
  },
  mounted(){
    typeService.getAll().then(function (data) {
      this.product_types = data.data.map(function (obj) {
        return { value: obj.id, label: obj.name };
      })
      this.batch.product_type_id = this.product_types[0].value;
    }.bind(this))

    providerService.getAll().then(function (data) {
      this.providers = data.data.map(function (obj) {
        return { value: obj.id, label: obj.name };
      })
      this.batch.provider_id = this.providers[0].value;
    }.bind(this))

    batchService.getAll().then(function (data) {
      this.batches = data.data.map(function (obj) {
        return { value: obj.id, label: obj.reference };
      })
      this.last_batch_id = this.batches[this.batches.length-1].value;
    }.bind(this))

  }
}

</script>
